import React from 'react';
import { View } from 'react-native';
import { useTheme } from '@ui-kitten/components';

import ListItemLoader from '../../../Components/ListItemLoader';
import { RectangleLoader } from '../../../Components/Loader';
import themeStyle from '../../../Theme/styles';

import { ids, styles } from './MapAndInfo';

const MapAndInfoLoader = () => {
  const theme = useTheme();
  return (
    <View
      dataSet={{ media: ids.locAndHoursContainer }}
      style={[
        themeStyle.flex1,
        themeStyle.pageVerticalSpacing,
        styles.locAndHoursContainer,
      ]}
    >
      <View style={themeStyle.flex1}>
        <RectangleLoader width="100%" height={350} />
      </View>
      <View
        dataSet={{ media: ids.locationContainer }}
        style={styles.locationContainer}
      >
        <View
          style={[
            themeStyle.pageVerticalSpacingMedium,
            themeStyle.pageHorizontalSpacingSmall,
            {
              borderRadius: 4,
              borderWidth: 1,
              borderColor: theme['color-info-500'],
            },
          ]}
        >
          <View style={[themeStyle.flex1, themeStyle.spacingBottomMedium]}>
            <ListItemLoader textSize={25.5} withLeftIcon />
          </View>
          <View style={themeStyle.spacingBottomMedium}>
            <ListItemLoader textSize={25.5} withLeftIcon />
          </View>
          <ListItemLoader textSize={25.5} withLeftIcon />
        </View>
      </View>
    </View>
  );
};

export default MapAndInfoLoader;
